import React from 'react';
import PropTypes from 'prop-types';
import { useStoreId } from '@thd-nucleus/experience-context';

import { FrequentlyBoughtTogetherProvider } from './contexts/FrequentlyBoughtTogetherContext';

import { dataModel } from './dataModel';

import { MainFBT } from './MainFBT';
import './frequently-bought-together.style.scss';

const FrequentlyBoughtTogether = (props) => {

  const { itemId, openInNewTab, onLoadDynamicRecs } = props;

  const storeId = useStoreId();

  return (
    <FrequentlyBoughtTogetherProvider
      storeId={storeId}
      itemId={itemId}
      onLoadDynamicRecs={onLoadDynamicRecs}
    >
      <MainFBT itemId={itemId} openInNewTab={openInNewTab} />
    </FrequentlyBoughtTogetherProvider>

  );
};

FrequentlyBoughtTogether.displayName = 'FrequentlyBoughtTogether';

FrequentlyBoughtTogether.propTypes = {
  itemId: PropTypes.string.isRequired,
  onLoadDynamicRecs: PropTypes.func,
  openInNewTab: PropTypes.bool
};

FrequentlyBoughtTogether.defaultProps = {
  onLoadDynamicRecs: null,
  openInNewTab: false
};

FrequentlyBoughtTogether.dataModel = dataModel;

export default FrequentlyBoughtTogether;